var chunkMapping = {
	"src_containers_ReceivingApp_index_ts": [
		"webpack/container/remote/receiving/ReceivingApp"
	],
	"src_containers_GameApp_index_ts": [
		"webpack/container/remote/game/GameApp"
	],
	"src_containers_CourierDeviceApp_index_ts": [
		"webpack/container/remote/courierDevice/CourierDeviceApp"
	],
	"src_containers_ReceivingDeviceApp_index_ts": [
		"webpack/container/remote/receivingDevice/ReceivingDeviceApp"
	],
	"src_containers_PlacementApp_index_ts": [
		"webpack/container/remote/placement/PlacementApp"
	],
	"src_containers_ReturnApp_index_ts": [
		"webpack/container/remote/returnApp/ReturnApp"
	],
	"src_containers_StorageApp_index_ts": [
		"webpack/container/remote/storage/StorageApp"
	],
	"src_containers_LaundryApp_index_ts": [
		"webpack/container/remote/laundry/LaundryApp"
	],
	"src_containers_C2CApp_index_ts": [
		"webpack/container/remote/c2c/C2CApp"
	],
	"src_containers_SwissPostC2CApp_index_ts": [
		"webpack/container/remote/swissPostC2C/SwissPostC2CApp"
	],
	"src_containers_DropOffApp_index_ts": [
		"webpack/container/remote/dropOff/DropOffApp"
	],
	"src_containers_VendingApp_index_ts": [
		"webpack/container/remote/vending/VendingApp"
	],
	"src_containers_ServiceMenuApp_index_ts": [
		"webpack/container/remote/serviceMenu/ServiceMenuApp"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/receiving/ReceivingApp": [
		"default",
		"./ReceivingApp",
		"webpack/container/reference/receiving"
	],
	"webpack/container/remote/game/GameApp": [
		"default",
		"./GameApp",
		"webpack/container/reference/game"
	],
	"webpack/container/remote/courierDevice/CourierDeviceApp": [
		"default",
		"./CourierDeviceApp",
		"webpack/container/reference/courierDevice"
	],
	"webpack/container/remote/receivingDevice/ReceivingDeviceApp": [
		"default",
		"./ReceivingDeviceApp",
		"webpack/container/reference/receivingDevice"
	],
	"webpack/container/remote/placement/PlacementApp": [
		"default",
		"./PlacementApp",
		"webpack/container/reference/placement"
	],
	"webpack/container/remote/returnApp/ReturnApp": [
		"default",
		"./ReturnApp",
		"webpack/container/reference/returnApp"
	],
	"webpack/container/remote/storage/StorageApp": [
		"default",
		"./StorageApp",
		"webpack/container/reference/storage"
	],
	"webpack/container/remote/laundry/LaundryApp": [
		"default",
		"./LaundryApp",
		"webpack/container/reference/laundry"
	],
	"webpack/container/remote/c2c/C2CApp": [
		"default",
		"./C2CApp",
		"webpack/container/reference/c2c"
	],
	"webpack/container/remote/swissPostC2C/SwissPostC2CApp": [
		"default",
		"./SwissPostC2CApp",
		"webpack/container/reference/swissPostC2C"
	],
	"webpack/container/remote/dropOff/DropOffApp": [
		"default",
		"./DropOffApp",
		"webpack/container/reference/dropOff"
	],
	"webpack/container/remote/vending/VendingApp": [
		"default",
		"./VendingApp",
		"webpack/container/reference/vending"
	],
	"webpack/container/remote/serviceMenu/ServiceMenuApp": [
		"default",
		"./ServiceMenuApp",
		"webpack/container/reference/serviceMenu"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}